export default function filterDesktop() {
  const filterDesktop = document.querySelector('.filter-desktop')
  const btnClear = document.querySelector('.filter-desktop__btn-clear')
  if(!filterDesktop) return

  btnClear.addEventListener('click', () => {
    clearForm()
  })

  function clearForm() {
    const options = filterDesktop.querySelectorAll('option')
    const selected = filterDesktop.querySelectorAll('.select__item_selected')
    const inputMin = filterDesktop.querySelector('input[name="min-price"]')
    const inputMinSub = filterDesktop.querySelector('input[name="min-sub-price"]')
    const inputMax = filterDesktop.querySelector('input[name="max-price"]')
    const inputMaxSub = filterDesktop.querySelector('input[name="max-sub-price"]')
    options.forEach(option => {
      if(option.selected) {
        option.selected = false
      }
    })
    selected.forEach(select => {
      select.classList.remove('select__item_selected')
    })
    inputMin.value = 0
    inputMax.value = 4000
    inputMinSub.value = 0
    inputMaxSub.value = 4000
  }
}